import { ExtractPdfItemType } from 'services/newServices'
import { OptionCompany } from '../CompareCompanyReport/hook'

export type ContentPdfAIProps = {
  handleSetPagePdf: (e: string, type?: boolean) => void
  data: ExtractPdfItemType[]
  loading: boolean
  error?: boolean
  newsId?: string
  pdfPage?: string
  block?: string
  baseNewsId?: string
  selectedNewsId?: string
  company?: OptionCompany
  isDetailModalOpen?: boolean
}

export const useContentPdfAI = (props: ContentPdfAIProps) => {
  return {
    ...props,
  }
}
